<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-6 mt-2 mt-8 sm:-mt-px mb-8">
        <div class="font-bold pt-6 text text-blue-500 tracking-wide uppercase">
            {{ $t('Purchase Side') }}
        </div>

        <fee-revenue
            :commission_detail="commission_detail"
            @updated="feeUpdated"
            :read_only="read_only"
        />

        <referral-fees
            :fee="fee"
            :commission_detail="commission_detail"
            @updated="referralFeesUpdated"
            :read_only="read_only"
        />

        <concession
            :commission_detail="commission_detail"
            :paid_off_top="purchase_side_paid_off_top"
            v-model="purchase_side_sale_concession"
            @updated="paidOffTopUpdated"
            :read_only="read_only"
        />

        <bonus
            v-model="purchase_side_sale_bonus"
            :read_only="read_only"
        />

        <net-fee
            :net_fee="net_fee"
            :net_to_agent="net_to_agent"
            v-model="purchase_side_percent_split"
            :read_only="read_only"
        />

        <other-fees
            :commission_detail="commission_detail"
            v-model="purchase_side_other_fees"
            :read_only="read_only"
        />

        <total-net-to-agent
            :total_net_to_agent="total_net_to_agent"
            :read_only="read_only"
        />

        <managing-broker-approved
            :commission_detail="commission_detail"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import FeeRevenue from './purchase-side/fee-revenue.vue';
import Bonus from './purchase-side/bonus.vue';
import Concession from './purchase-side/concession.vue';
import NetFee from './purchase-side/net-fee.vue';
import OtherFees from './purchase-side/other-fees.vue';
import TotalNetToAgent from './purchase-side/total-net-to-agent.vue';
import ManagingBrokerApproved from './purchase-side/managing-broker-approved.vue';
import ReferralFees from './purchase-side/referral-fees.vue';
import MoneyFunctions from '../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    components: {
        FeeRevenue,
        Bonus,
        Concession,
        NetFee,
        OtherFees,
        TotalNetToAgent,
        ManagingBrokerApproved,
        ReferralFees,
    },

    props: {
        commission_detail: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            purchase_side_sale_revenue: this.commission_detail.purchase_side_sale_revenue,
            purchase_side_sale_bonus: this.commission_detail.purchase_side_sale_bonus,
            purchase_side_sale_concession: this.commission_detail.purchase_side_sale_concession,
            purchase_side_paid_off_top: this.commission_detail.purchase_side_paid_off_top,
            purchase_side_percent_split: this.commission_detail.purchase_side_percent_split,
            purchase_side_other_fees: this.commission_detail.purchase_side_other_fees,
            purchase_side_referral_fee_total: this.commission_detail.purchase_side_referral_fee_total,        }
    },

    computed: {
        fee() {
            return this.moneyVal(this.purchase_side_sale_revenue);
        },
        referral_fee() {
            return this.moneyVal(this.purchase_side_referral_fee_total);
        },
        concession() {
            return this.moneyVal(this.purchase_side_sale_concession);
        },
        bonus() {
            return this.moneyVal(this.purchase_side_sale_bonus);
        },
        net_fee() {
            return this.formatMoney(
                this.fee
                - this.referral_fee
                - (this.purchase_side_paid_off_top ? this.concession : 0)
                + this.bonus
            );
        },
        net_to_agent() {
            if (! this.net_fee || ! this.purchase_side_percent_split) {
                return null;
            }

            return this.formatMoney(
                this.net_fee
                * (this.purchase_side_percent_split / 100)
                - (this.purchase_side_paid_off_top ? 0 : this.concession)
            );
        },
        total_net_to_agent() {
            return this.formatMoney(this.net_to_agent - this.moneyVal(this.purchase_side_other_fees));
        },
    },

    methods: {
        feeUpdated(val) {
            this.purchase_side_sale_revenue = val;
        },
        referralFeesUpdated(val) {
            this.purchase_side_referral_fee_total = val;
        },
        paidOffTopUpdated(val) {
            this.purchase_side_paid_off_top = val;
        },
    },

    watch: {
        total_net_to_agent(val) {
            store.state.purchase_side_total_net_to_agent = val;
        },
    },
}
</script>
